//App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import AdminRoutes from './routes/AdminRoutes';
import RestaurantRoutes from './routes/RestaurantRoutes';
import BranchRoutes from './routes/BranchRoutes';
import KitchenRoutes from './routes/KitchenRoutes';
import CashierRoutes from './routes/CashierRoutes';
import LoginRoutes from './routes/LoginRoutes';

function RoleBasedRoutes() {
  const { user, authState } = useAuth();

  // Show loading spinner while checking auth status
  if (authState.loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        Loading...
      </div>
    );
  }

  // If not authenticated, show login routes
  if (!authState.isAuthenticated) {
    return (
      <Routes>
        <Route path="/*" element={<LoginRoutes />} />
      </Routes>
    );
  }

  // If authenticated but no role, redirect to login
  if (!user?.role) {
    return <Navigate to="/" replace />;
  }

  // Role-based routing for authenticated users
  return (
    <Routes>
      {user.role === "admin" && <Route path="/*" element={<AdminRoutes />} />}
      {user.role === "restaurant" && <Route path="/*" element={<RestaurantRoutes />} />}
      {user.role === "branch" && <Route path="/*" element={<BranchRoutes />} />}
      {user.role === "kitchen" && <Route path="/*" element={<KitchenRoutes />} />}
      {user.role === "cashier" && <Route path="/*" element={<CashierRoutes />} />}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <Router>
        <AuthProvider>
          <RoleBasedRoutes />
        </AuthProvider>
      </Router>
    </>
  );
}

export default App;